export function getDisplayValue(value: unknown): unknown {
  if (value == null) return value
  if (typeof value !== 'object') return value
  if ('value' in value) return getDisplayValue((value as { value: unknown }).value)
  if (Array.isArray(value)) return value.map((item) => getDisplayText(item)).filter(Boolean).join(', ')

  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

export function getDisplayText(value: unknown): string {
  const displayValue = getDisplayValue(value)
  return displayValue == null ? '' : String(displayValue)
}

const REFERENCE_FIELD_IDS = new Set(['reference_no', 'slip_ref', 'reference'])

export function isReferenceField(fieldId: string): boolean {
  return REFERENCE_FIELD_IDS.has(fieldId)
}

/** @deprecated Use isReferenceField */
export const isTableReferenceField = isReferenceField

/** Format reference numbers as first 8 + ... + last 5 */
export function formatReferenceNo(value: string): string {
  const trimmed = value.trim()
  if (!trimmed) return trimmed

  const normalized = trimmed.replace(/\s+/g, '')
  if (normalized.length < 14 || !/^[0-9A-Za-z]+$/.test(normalized)) {
    return trimmed
  }

  return `${normalized.slice(0, 8)}...${normalized.slice(-5)}`
}

/** @deprecated Use formatReferenceNo */
export const maskTableReferenceNo = formatReferenceNo
